import { RenderTiles } from '../../components/common';
// import { VscServerProcess } from 'react-icons/vsc';
// import { FcInspection } from 'react-icons/fc';
// import { MdApproval } from 'react-icons/md';
import { TbFileReport, TbReport } from 'react-icons/tb';
// import { TbReportAnalytics } from 'react-icons/tb';
// import { HiDocumentReport } from 'react-icons/hi';
// import { RiDeleteBin4Fill } from 'react-icons/ri';
import { TfiReceipt } from 'react-icons/tfi';
import { RiHospitalLine } from 'react-icons/ri';
import { CgCalendarToday } from 'react-icons/cg';
import { VscServerProcess } from 'react-icons/vsc';
import { RiDeleteBin4Fill } from 'react-icons/ri';
import { CgPlayListSearch } from 'react-icons/cg';
import { GiEntryDoor } from 'react-icons/gi';
import { MdOutlineLiveHelp } from 'react-icons/md';

const supervisorTilesObj = [
  // {
  //   sNo: 1,
  //   link: '/supervisor/lineInspectionList',
  //   isLink: true,
  //   icon: <VscServerProcess size="5rem" color="#a12222" />,
  //   p: 'LINE',
  //   span: 'INSPECTION',
  //   isIcon: true,
  // },

  // {
  //   sNo: 1,
  //   link: '/supervisor/setupList',
  //   isLink: true,
  //   icon: <MdApproval size="5rem" color="#a12222" />,
  //   p: 'FPA/',
  //   span: 'LPA',
  //   isIcon: true,
  // },
  // {
  //   sNo: 1,
  //   link: '/supervisor/materialIncomingList',
  //   isLink: true,
  //   icon: <FcInspection size="5rem" color="#a12222" />,
  //   p: 'MATERIAL INCOMING',
  //   span: 'INSPECTION',
  //   isIcon: true,
  // },
  // {
  //   sNo: 2,
  //   link: '/supervisor/dailyProductionList',
  //   isLink: true,
  //   icon: <TbReportAnalytics size="5rem" color="#064a29" />,
  //   p: 'DAILY PRODUCTION STROKES',
  //   span: 'REPORT',
  //   isIcon: true,
  // },

  // {
  //   sNo: 2,
  //   link: '/supervisor/rotorHourlyProductionList',
  //   isLink: true,
  //   icon: <TbFileReport size="5rem" color="#a12222" />,
  //   p: 'ROTOR HOURLY',
  //   span: 'PRODUCTION ROTOR',
  //   isIcon: true,
  // },
  // {
  //   sNo: 3,
  //   link: '/supervisor/dailyProductionRotorDailyRejectionList',
  //   isLink: true,
  //   icon: <TbReport size="5rem" color="#a12222" />,
  //   p: 'DAILY REJECTION',
  //   span: 'NOTE ROTOR',
  //   isIcon: true,
  // },
  // {
  //   sNo: 4,
  //   link: '/supervisor/dailyProductionStrokesList',
  //   isLink: true,
  //   icon: <TbReportAnalytics size="5rem" color="#064a29" />,
  //   p: 'DAILY PRODUCTION STROKES',
  //   span: 'REPORT',
  //   isIcon: true,
  // },
  // {
  //   sNo: 5,
  //   link: '/supervisor/dailyProductionRedBinList',
  //   isLink: true,
  //   icon: <RiDeleteBin4Fill size="5rem" color="#a12222" />,
  //   p: 'DAILY PRODUCTION REDBIN',
  //   span: 'REPORT',
  //   isIcon: true,
  // },
  {
    sNo: 4,
    link: '/supervisor/tagList',
    isLink: true,
    icon: <TfiReceipt size="5rem" color="#c92a2a" />,
    p: 'Generate',
    span: 'Dispatch Tag',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/riDepartment',
    isLink: true,
    icon: <GiEntryDoor size="5rem" color="#a12222" />,
    p: 'RI',
    span: 'DEPARTMENT',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/production',
    isLink: true,
    icon: <CgCalendarToday size="5rem" color="#212529" />,
    p: 'PRODUCTION',
    span: 'MANAGEMENT',
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/supervisor/pdirList',
    isLink: true,
    icon: <TbReport size="5rem" color="#a12222" />,
    p: 'PDIR',
    span: 'REPORT',
    isIcon: true,
  },
  {
    sNo: 1,
    link: '/common/pirList',
    isLink: true,
    icon: <VscServerProcess size="5rem" color="#135089" />,
    p: 'PIR',
    span: 'REPORT',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/scrapNoteList',
    isLink: true,
    icon: <RiDeleteBin4Fill size="5rem" color="#a12222" />,
    p: 'SCRAP NOTE',
    span: 'REPORT',
    isIcon: true,
  },
  {
    sNo: 8,
    link: '/common/machineCheckSheet',
    isLink: true,
    icon: <CgPlayListSearch size="5rem" color="#003566" />,
    p: 'MACHINE',
    span: 'CHECK SHEET',
    isIcon: true,
  },

  {
    sNo: 9,
    link: `/common/mushinHelpDesk`,
    isLink: true,
    icon: <MdOutlineLiveHelp size="5rem" color="#003566" />,
    p: 'MUSHIN HELP',
    span: 'DESK',
    isIcon: true,
  },
];

const SupervisorHome = () => {
  return <RenderTiles tilesObj={supervisorTilesObj} height="100vh" />;
};

export default SupervisorHome;
